import { createAction } from 'redux-actions';
import { PapiComment, PapiBadge } from '@wix/da-papi-types';
import { actionTypePrefix } from './constants';
import { RequestError } from './types';

export const updateCommentBadges = createAction(
  `${actionTypePrefix}/UPDATE_COMMENT_BADGES`,
  (comment: Partial<PapiComment>, allBadges: PapiBadge[]) => ({
    comment,
    allBadges,
  })
);

export const likeComment = createAction(`${actionTypePrefix}/LIKE`, (comment: PapiComment) => ({
  comment,
}));

export const unlikeComment = createAction(`${actionTypePrefix}/UNLIKE`, (comment: PapiComment) => ({
  comment,
}));

export const reportComment = createAction(`${actionTypePrefix}/REPORT`, (comment: PapiComment) => ({
  comment,
}));

export const featureComment = createAction(
  `${actionTypePrefix}/FEATURE`,
  (comment: PapiComment) => ({
    comment,
  })
);

export const unfeatureComment = createAction(
  `${actionTypePrefix}/UNFEATURE`,
  (comment: PapiComment) => ({
    comment,
  })
);

export const hideComment = createAction(
  `${actionTypePrefix}/HIDE`,
  (comment: PapiComment, insideModal: boolean) => ({
    comment,
    insideModal,
  })
);

export const unhideComment = createAction(`${actionTypePrefix}/UNHIDE`, (comment: PapiComment) => ({
  comment,
}));

export const requestSuccess = createAction(
  `${actionTypePrefix}/SUCCESS`,
  (actionType: string, comment: PapiComment) => ({
    isBusy: false,
    comment,
    actionType,
  })
);

export const requestFailure = createAction(
  `${actionTypePrefix}/FAILURE`,
  (actionType: string, comment: PapiComment, error: RequestError) => ({
    comment,
    error,
    actionType,
  })
);

export const reduxModuleLoaded = createAction(
  `${actionTypePrefix}/REDUX_MODULE_LOADED`,
  () => ({})
);
